import styled from 'styled-components';
import { typography } from '@cld/typography';
import { globalTheme } from '@cld/component-theme';

export const GroupHeader = styled.div`
  ${typography.xs.lowContrast};
  padding: ${globalTheme.spacing.xs} ${globalTheme.spacing.sm};
`;
